export class GooglePayJSRequestError extends Error {
  constructor(src: string) {
    super(`Unable to load script ${src}`);
    this.name = 'GooglePayJSRequestError';
  }
}
